module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "head_wrap clearfix"
  }, [_vm._m(0), _vm._v(" "), (_vm.is_logined !== null) ? _c('div', {
    staticClass: "user_msg"
  }, [_c('a', {
    attrs: {
      "href": _vm.urls.naFaq,
      "target": "_blank"
    }
  }, [_vm._v("FAQ")]), _vm._v(" "), (_vm.is_logined) ? _c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n          My Account\n          "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "account-menu",
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/resetcode')
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")])], 1)], 1) : _c('a', {
    attrs: {
      "href": _vm.direction
    }
  }, [_vm._v("Sign in")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("@img/logo3.png"),
      "alt": "logo",
      "width": "40"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Teacher Application Portal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c724e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/public/header.vue
// module id = 839
// module chunks = 1